// extracted by mini-css-extract-plugin
module.exports = {"container":"SpecialPartnership_container__RKsCU","image":"SpecialPartnership_image__n1gue","partnershipImage":"SpecialPartnership_partnershipImage__frKre"};